// Hook odpowiedzialny za aktualizację reklamacji / zamówienia

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

// typ zwracanych danych
type IResponse = ICommandResponseSuccess;

const putReturnComplaintCancel = (returnComplainId: number): Promise<IResponse> =>
  axios.put(`/return-complain/${returnComplainId}/cancel`);

export const usePutReturnComplaintCancel = (
  options?: UseMutationOptions<IResponse, IError, number>
) => useMutation<IResponse, IError, number>((id: number) => putReturnComplaintCancel(id), options);
